import React from "react";
import PropTypes from "prop-types";
import {Fab, Tooltip} from "@mui/material";
import ArrowBackOutlinedIcon from "@mui/icons-material/ArrowBackOutlined";
import {makeStyles} from "tss-react/mui";
import {useRegScoutCore} from "../resources/RegScoutCoreProvider";

export const useBackArrowPlatformStyles = makeStyles()((theme, {sidebarWidth}) => ({
  backArrowPlatformButton: {
    position: "fixed",
    top: theme.spacing(18),
    left: sidebarWidth ? `${sidebarWidth}px` : theme.spacing(28),
    transition: "left 225ms cubic-bezier(0.4, 0, 0.6, 1)",
    borderRadius: 0,
    width: "40px",
    height: "45px",
    [theme.breakpoints.down("sm")]: {
      top: theme.spacing(16),
      left: "0px",
      width: "30px",
    },
  },
}));

const BackArrowPlatform = ({onClick}) => {
  const {sidebarWidth} = useRegScoutCore();
  const {classes} = useBackArrowPlatformStyles({sidebarWidth});

  return (
    <>
      <Tooltip title="Back" placement="right">
        <Fab
          color="primary"
          aria-label="filters"
          className={classes.backArrowPlatformButton}
          onClick={() => onClick()}
        >
          <ArrowBackOutlinedIcon />
        </Fab>
      </Tooltip>
    </>
  );
};

BackArrowPlatform.propTypes = {
  onClick: PropTypes.func,
};

export default BackArrowPlatform;
